export default function getSvgProps({ 'aria-label': ariaLabel, defaultClassName, className, svgWidth, svgHeight, svgPath }) {
  const width = svgWidth;
  const height = svgHeight;
  const path = svgPath;

  if (ariaLabel) {
    return {
      version: '1.1',
      focusable: 'false',
      viewBox: `0 0 ${width} ${height}`,
      className: className ? [defaultClassName + '  ' + className] : defaultClassName,
      'aria-label': ariaLabel,
      role: 'img',
      dangerouslySetInnerHTML: { __html: path },
    };
  } else {
    return {
      version: '1.1',
      focusable: 'false',
      viewBox: `0 0 ${width} ${height}`,
      className: className ? [defaultClassName + '  ' + className] : defaultClassName,
      'aria-hidden': 'true',
      dangerouslySetInnerHTML: { __html: path },
    };
  }
}
